import { Button, MenuItem, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { getTasks } from "api/services/tasks";
import Loader from "components/Loader";
import SearchContainer from "components/SearchContainer";
import { UserProfileContext } from "context/UserProfile";
import { useContext, useState } from "react";
import { useMutation, useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { ResType } from "types";
import TaskTable from "views/Tasks/index";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { exportTasksPageReport } from "api/services/reports";
import { getCurrentFormattedDateTime } from "utils";
import TaskListView from "views/Tasks/ListViewgrid";

function Tasks(state) {
  const [search, setSearch] = useState("");
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [totalCount, setTotalCount] = useState<number>(0);
  const clientId = localStorage.getItem("clientId");

  const { data, isLoading, error }: ResType = useQuery(
    [
      "tasks",
      {
        client: clientId,
        search: search,
        limit: pageCount,
        offset: page * pageCount,
        removeCompleted: false,
      },
    ],
    getTasks, {
    onSuccess: (res) => {
      setTotalCount(res?.data?.[1])
    },
  }
  );

  const { mutate } = useMutation(exportTasksPageReport, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      const formattedDateTime = getCurrentFormattedDateTime();
      link.href = file;
      link.download = `ATOM - Main Task ${formattedDateTime}.xlsx`;
      link.click();
      const message = "Main Task exported successfully";
      snack.success(message);

    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });

  const setSearchChange = (e) => {
    setSearch(e);
    setPage(0);
  };

  const getFiltersData = () => {
    let result = {};

    return {
      ...result,
    };
  };
  const clientchanged = (client: any) => {
    return client;
  };

  const handleExport = () => {
    mutate({
      ...state,
      search: search,
      ...getFiltersData(),
      client: clientchanged(clientId),
    });
  };

  return (
    <Box pl={1} pr={1}>
      <TaskListView /> 
      <Box pr={2} pl={2} sx={{ display: "flex", justifyContent: "flex-end", alignItems: "center", mt: 0, pt: 0 }}>
        <SearchContainer
          minWidth="400px"
          value={search}
          debounced
          placeHolder="Search by Task ID | Task Name"
          onChange={setSearchChange}
        />
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleExport}
          startIcon={<FileDownloadOutlinedIcon />}
        >
          Export
        </Button>
      </Box>
      {isLoading ? (
        <Loader />
      ) : (
        <TaskTable
          tab="client-task"
          data={data?.data?.[0]}
          totalCount={totalCount}
          page={page}
          pageCount={pageCount}
          setPageCount={setPageCount}
          setPage={setPage}
        />
      )}
    </Box>
  );
}

export default Tasks;